import { render } from "./SerenePrivacyPolicyPT.vue?vue&type=template&id=67a56ad3"
import script from "./SerenePrivacyPolicyPT.vue?vue&type=script&lang=js"
export * from "./SerenePrivacyPolicyPT.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__